import { Pipe, PipeTransform, inject } from '@angular/core';
import { WarningMessageHelper } from '../helpers/warning-message-helper';
import { VehicleWarning, WarningMessageType } from '../models';

@Pipe({
    name: 'formatWarningMessage'
})
export class WarningMessagePipe implements PipeTransform {
    private _helper = inject(WarningMessageHelper);


    constructor() {
    }

    transform(value: VehicleWarning): string {
        if (!value) {
            return '';
        }

        if (value instanceof VehicleWarning) {
            return this._helper.getMessage(value);
        }

        return '';
    }
}



@Pipe({
    name: 'formatWarningMessageType'
})
export class WarningMessageTypePipe implements PipeTransform {
    private _helper = inject(WarningMessageHelper);


    constructor() {
    }

    transform(value: WarningMessageType, format: string = 'title'): string {
        if (!value) {
            return '';
        }

        if (format === 'title') {
            return this._helper.getTitle(value);
        } else if (format === 'shortHeader') {
            return this._helper.getShortHeader(value);
        } else if (format === 'description') {
            return this._helper.getDescription(value);
        }

        return '';
    }
}
